import { Anchor, Box, Flex, Image, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import classes from "../list.module.css";

type Props = {
  name?: string | null;
  /** Secondary mono line, e.g. "INV-100191 · 08-19" */
  code?: string | null;
  logo?: string | null;
  /**
   * Makes the code line a real link, so a row that opens on click can also be
   * reached by keyboard and opened in a new tab.
   */
  codeHref?: string | null;
};

function initials(name?: string | null): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return "-";
  const chars = Array.from(trimmed);
  return chars.slice(0, 2).join("").toUpperCase();
}

export function PartyCell({ name, code, logo, codeHref }: Props) {
  const displayName = (name ?? "").trim();
  const displayCode = (code ?? "").trim();

  if (!displayName && !displayCode) {
    return (
      <Text size="sm" c="dimmed">
        -
      </Text>
    );
  }

  return (
    <Flex align="center" gap={12} miw={0}>
      <Box className={classes.partyAvatar}>
        {logo ? (
          <Image src={logo} alt="" w={34} h={34} fit="cover" />
        ) : (
          initials(displayName || displayCode)
        )}
      </Box>
      <Flex direction="column" gap={2} miw={0}>
        <Text className={classes.partyName} truncate="end">
          {displayName || "-"}
        </Text>
        {displayCode &&
          (codeHref ? (
            <Anchor
              component={Link}
              to={codeHref}
              className={`${classes.partyCode} ${classes.partyCodeLink}`}
              truncate="end"
              // The row navigates on click too; let the link alone handle it (incl. Ctrl/middle-click).
              onClick={(e) => e.stopPropagation()}
            >
              {displayCode}
            </Anchor>
          ) : (
            <Text className={classes.partyCode} truncate="end">
              {displayCode}
            </Text>
          ))}
      </Flex>
    </Flex>
  );
}
